var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHambruger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.5V11.5C24 11.7652 23.8946 12.0196 23.7071 12.2071C23.5196 12.3946 23.2652 12.5 23 12.5H1C0.734784 12.5 0.48043 12.3946 0.292893 12.2071C0.105357 12.0196 0 11.7652 0 11.5V9.5C0 9.23478 0.105357 8.98043 0.292893 8.79289C0.48043 8.60536 0.734784 8.5 1 8.5H23C23.2652 8.5 23.5196 8.60536 23.7071 8.79289C23.8946 8.98043 24 9.23478 24 9.5ZM23 16.5H1C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5V19.5C0 19.7652 0.105357 20.0196 0.292893 20.2071C0.48043 20.3946 0.734784 20.5 1 20.5H23C23.2652 20.5 23.5196 20.3946 23.7071 20.2071C23.8946 20.0196 24 19.7652 24 19.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5ZM23 0.5H1C0.734784 0.5 0.48043 0.605357 0.292893 0.792893C0.105357 0.98043 0 1.23478 0 1.5V3.5C0 3.76522 0.105357 4.01957 0.292893 4.20711C0.48043 4.39464 0.734784 4.5 1 4.5H23C23.2652 4.5 23.5196 4.39464 23.7071 4.20711C23.8946 4.01957 24 3.76522 24 3.5V1.5C24 1.23478 23.8946 0.98043 23.7071 0.792893C23.5196 0.605357 23.2652 0.5 23 0.5Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHambruger);
export default __webpack_public_path__ + "static/media/hambruger.a66214d88283e0e4267201797eff2032.svg";
export { ForwardRef as ReactComponent };